import { ComponentType } from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { createIncrementCounterAction } from "../redux/actions/incrementCounterAction";
import { createSetCounterAction } from "../redux/actions/setCounterAction";
import { createSetCurrentModuleDataAction } from "../redux/actions/setCurrentModuleDataAction";
import { createSetCurrentTagCollectionAction } from "../redux/actions/setCurrentTagCollectionAction";

export type WithActions = {
    actions: {
        setCounter: typeof createSetCounterAction;
        incrementCounter: typeof createIncrementCounterAction;
        setCurrentTagCollection: typeof createSetCurrentTagCollectionAction;
        setCurrentModuleData: typeof createSetCurrentModuleDataAction;
    };
};

const wrapDispatch = <T extends Action, U extends unknown[]>(dispatch: Dispatch<T>, fn: (...args: U) => T) => {
    return (...args: U) => {
        return dispatch(fn(...args));
    };
};

export const withActions = <TProps>(Component: ComponentType<TProps & WithActions>): ComponentType<TProps> => {
    const mapDispatchToProps = (dispatch: Dispatch): WithActions => {
        return {
            actions: {
                setCounter: wrapDispatch(dispatch, createSetCounterAction),
                incrementCounter: wrapDispatch(dispatch, createIncrementCounterAction),
                setCurrentTagCollection: wrapDispatch(dispatch, createSetCurrentTagCollectionAction),
                setCurrentModuleData: wrapDispatch(dispatch, createSetCurrentModuleDataAction),
            },
        };
    };

    return connect(undefined, mapDispatchToProps)(Component as ComponentType<unknown>);
};
